import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { baseURL } from "../constants/baseUrl";

const storageKey = "rb.analytics.visitor.v1";
const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
let memoryVisitor;

const uuid = () => {
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 15) | 64;
  bytes[8] = (bytes[8] & 63) | 128;
  const hex = Array.from(bytes, byte => byte.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
};

const visitorId = () => {
  try {
    const saved = localStorage.getItem(storageKey);
    if (uuidPattern.test(saved)) return saved;
  } catch { /* Private browsing may deny storage; keep an in-memory identity. */ }
  if (!memoryVisitor) memoryVisitor = uuid();
  try { localStorage.setItem(storageKey, memoryVisitor); } catch { /* Best effort. */ }
  return memoryVisitor;
};

// Mounted once outside the route tree. Only pathname changes are page views;
// search/hash changes and React effect replays do not inflate the count.
export default function VisitTracker() {
  const { pathname } = useLocation();
  const lastPath = useRef(null);
  useEffect(() => {
    if (lastPath.current === pathname) return;
    lastPath.current = pathname;
    if (/^\/(miniapps?|admin)(\/|$)/i.test(pathname)) return;
    try {
      fetch(`${baseURL.replace(/\/$/, "")}/visits`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "omit",
        keepalive: true,
        body: JSON.stringify({ eventId: uuid(), visitorId: visitorId(), pathname }),
      }).catch(() => {});
    } catch { /* Analytics must never interrupt navigation. */ }
  }, [pathname]);
  return null;
}
